import { create } from "zustand";

interface ServiceDrawerState {
  id: number | string;
  isOpen: boolean;
  isScheduleReturnsOpen: boolean;
  isCancelReturnsOpen: boolean;
  vendor: string;
  onOpen: (id?: number | string) => void;
  onClose: (id?: number | string) => void;
  onOpenSchedule: (id?: number | string) => void;
  onCloseSchedule: (id?: number | string) => void;
  // onOpenCancel: (id?: number | string) => void;
  onOpenCancel: (id?: number | string) => void;

  onCloseCanel: () => void;
  syncReturns: number;
  setSyncReturns: () => void;
}

export const useServiceDrawer = create<ServiceDrawerState>((set) => ({

  syncReturns: 0,
  id: "",
  isOpen: false,
  isScheduleReturnsOpen: false,
  isCancelReturnsOpen: false,
  vendor: "",
  onOpen: (id) => set({ isOpen: true, id }),
  onClose: (id) => set({ isOpen: false, id }),
  onOpenSchedule: (id) => set({ isScheduleReturnsOpen: true, id }),
  onCloseSchedule: (id) => set({ isScheduleReturnsOpen: false, id }),
  // onOpenCancel: (id) => set({ isCancelReturnsOpen: true, id }),
  onOpenCancel: (id) => set({ isCancelReturnsOpen: true, id }),
  onCloseCanel: () => set({ isCancelReturnsOpen: false, id: "" }),
  setSyncReturns: () => set((state) => ({ syncReturns: state.syncReturns + 1 })),
}));